import { useState, useEffect } from 'react';
import '../../assets/styles/moedas.css';
import { animationModal } from "../../utils";
import backHeader from "../../assets/img/Back - Header.svg";
import { ModalInfos } from '../../components/modal';
import { ModalSure } from '../../components/modalExcluir';
import axiosInstance from '../../auth/axiosInstance';

export default function Moedas() {
  const [construction, setConstruction] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [coins, setCoins] = useState([]);
  const [eapApi, setEapApi] = useState('');
  const [selected, setSelected] = useState(null);

  const [codigo, setCodigo] = useState('');
  const [descricao, setDescricao] = useState('');
  let [petax, setPetax] = useState('');

  const [label, setlabel] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [labelError, setlabelError] = useState({ label: 'Erro ao atualizar Projeto!', sugestao: 'Favor tentar novamente' })
  const [moedaSelecionada, setMoedaSelecionada] = useState({})

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    getCoins(event.target.value)
    setEapApi(event.target.value)
  };

  useEffect(() => {
    axiosInstance(`filter/Eap_Info/`)
      .then((response) => { setConstruction(response.data) })
      .catch((error) => console.log(error))

    setCodigo(moedaSelecionada.moeda)
    setDescricao(moedaSelecionada.descricao)
    setPetax(moedaSelecionada.petax)
  }, [moedaSelecionada.moeda, moedaSelecionada.descricao, moedaSelecionada.petax]);

  function callDelete(moeda) {
    setMoedaSelecionada(moeda);
    setShowModal3(true);
  }

  function callClose() {
    animationModal('modal-new-action', 'background-new-plan')
    getCoins(eapApi)
  }

  async function getCoins(eap) {
    await axiosInstance(`moeda/${eap}`)
      .then((response) => { setCoins(response.data) })
      .catch((error) => console.log(error))
  }

  async function postMoeda() {
    if (petax.includes(',')) {
      petax = petax.replace(',', '.');
    }
    await axiosInstance.post(`moeda`, {
      "eapId": eapApi,
      "moeda": codigo,
      "descricao": descricao,
      "petax": petax
    })
      .then(res => {
        if (res.status === 201) {
          setlabel('Moeda adicionada com sucesso!')
          setShowModal(true)
          animationModal('modal-new-action-add', 'background-new-plan-add')
          setTimeout(() => {
          }, 100);
          setCodigo('')
          setDescricao('')
          setPetax('')
          getCoins(eapApi)
        }
      }).catch(error => {
        setShowModal2(true)
        setlabelError({ label: 'Erro ao alterar moeda', sugestao: 'Favor tentar novamente' })
      })
  }

  async function changeMoeda() {
    if (petax.includes(',')) {
      petax = petax.replace(',', '.');
    }
    try {
      await axiosInstance
        .put(`moeda/${moedaSelecionada.moeda}/${eapApi}`, {
          "eapId": eapApi,
          "moeda": codigo,
          "descricao": descricao,
          "petax": petax
        })
        .then((res) => {
          if (res.status === 200) {
            setlabel("Moeda alterada com sucesso!");
            setShowModal(true);
            setShowModal3(false);
            animationModal('modal-new-action', 'background-new-plan')
            getCoins(eapApi)
            setCodigo("")
            setDescricao("")
            setPetax("")
            setTimeout(() => {
              getCoins(eapApi)
            }, 100);
          }
        });
    } catch (error) {
      setlabelError({
        label: "Erro ao alterar Moeda!",
        sugestao: "Favor tente novamente",
      });
      setShowModal2(true);
      setShowModal3(false);
    }
  }

  async function deleteMoeda(moeda) {
    try {
      await axiosInstance
        .delete(`moeda/${moeda.moeda}/${eapApi}`)
        .then((res) => {
          if (res.status === 200) {
            setlabel("Moeda removida com sucesso!");
            setShowModal(true);
            setShowModal3(false);
            setTimeout(() => {
              getCoins(eapApi)
            }, 100);
          }
        });
    } catch (error) {
      setlabelError({
        label: "Erro ao deletar Moeda!",
        sugestao: "Favor tente novamente",
      });
      setShowModal2(true);
      setShowModal3(false);
    }
  }

  return (
    <>
      <section className="body-table-eap">
        <div className='header_coin'>
          <h1 className='title'>Moedas</h1>
          <span className='span_select'>Selecionar EAP <span className='red'>*</span></span>
          <select value={selectedOption} onChange={handleSelectChange} className='coin_select' >
            <option value="" disabled>Selecione o Projeto</option>
            {construction.map((element) => (
              <option key={element.eapId} value={element.eapId}>{element.eapId}</option>
            ))}
          </select>
        </div>
        <div className='coins__container'>
          <div className='coins__container_all'>
            {
              coins.map((element) => (
                <div className='coins__container_info_button'>
                  <div
                    key={element.moeda}
                    className="coins__container_info"
                    onClick={() => setSelected(element)}
                  >
                    <span className="coins__container_coin">{element.moeda}</span>
                    <span className="coins__container_petax">
                      {element.descricao} - Petax:{" "}
                      {element.petax.toLocaleString("pt-BR", {
                        style: "decimal",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                  {selected === element && (
                    <div className="options-cpu">
                      <button onClick={() => callDelete(element)}>Excluir</button>
                      <button
                        onClick={() => {
                          animationModal(
                            "modal-new-action",
                            "background-new-plan"
                          );
                          setMoedaSelecionada(element);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  )}
                </div>
              ))
            }
          </div>
          <div style={eapApi === '' ? { display: "none" } : { display: "block" }} className='newcoin__container'>
            <div className='newcoin__container_add'>
              <span className='newcoin__container_add_text'>Moeda não encontrada ?</span>
              <button onClick={() => animationModal('modal-new-action-add', 'background-new-plan-add')} className='newcoin__container_add_button'>Nova Moeda</button>
            </div>
          </div>
        </div>

        <div id="background-new-plan-add" className="background-new-plan">
          <section id="modal-new-action-add" className="modal-new-action">
            <div onClick={() => animationModal('modal-new-action-add', 'background-new-plan-add')} className="fechar-button-style">
              <img src={backHeader} alt='back' />
              <img src={backHeader} alt='back' />
              <h2 className="montserrat ">Fechar</h2>
            </div>
            <h1 className="montserrat azul w600">Adicionar Uma Nova Moeda</h1>
            <div>
              <div className="content-inputs">
                <div className="input-component">
                  <div>
                    <h3 className="montserrat">Moeda</h3>
                    <h5 className='w600'>*</h5>
                  </div>
                  <input name="codigo" placeholder='Write here' type='text' value={codigo} onChange={(event) => setCodigo(event.target.value)} />
                  <h4 className="montserrat">EXEMPLO: BRL</h4>
                </div>
                <div className="input-component">
                  <div>
                    <h3 className="montserrat">Descrição</h3>
                    <h5 className='w600'>*</h5>
                  </div>
                  <input placeholder='Write here' type='text' value={descricao} onChange={(event) => setDescricao(event.target.value)} />
                  <h4 className="montserrat">EXEMPLO: Real Brasileiro</h4>
                </div>
                <div className="input-component">
                  <div>
                    <h3 className="montserrat">PETAX</h3>
                    <h5 className='w600'>*</h5>
                  </div>
                  <input placeholder='Write here' type='text' value={petax} onChange={(event) => setPetax(event.target.value)} />
                  {/* < CurrencyInput 
                                    placeholder="5.85"
                                    value={petax}
                                    onChange={(event) => setPetax(event)}
                                /> */}
                  <h4 className="montserrat">EXEMPLO: 5.85</h4>
                </div>
              </div>
            </div>
            <div className="button-okay-modal">
              <button className="montserrat w600" onClick={() => animationModal('modal-new-action-add', 'background-new-plan-add')} >Cancelar</button>
              <button className="montserrat w600"
                onClick={() => postMoeda()}
                disabled={codigo === "" && descricao === "" && petax <= 0}
                style={codigo !== "" && descricao !== "" && parseFloat(petax) > 0 ? {} : { backgroundColor: '#ccc', cursor: 'not-allowed' }}>Adicionar
              </button>
            </div>
          </section>
        </div>

        <div id="background-new-plan" className="background-new-plan">
          <section id="modal-new-action" className="modal-new-action">
            <div
              onClick={() =>
                callClose()
              }
              className="fechar-button-style"
            >
              <img src={backHeader} alt="back" />
              <img src={backHeader} alt="back" />
              <h2 className="montserrat ">Fechar</h2>
            </div>
            <h1 className="montserrat azul w600">Alterar Moeda</h1>
            <div className="content-inputs">
              <div className="input-component">
                <div>
                  <h3 className="montserrat">Moeda</h3>
                  <h5 className='w600'>*</h5>
                </div>
                <input name="codigo" placeholder='Write here' disabled={true} type='text' value={codigo} onChange={(event) => setCodigo(event.target.value)} />
                <h4 className="montserrat">EXEMPLO: BRL</h4>
              </div>
              <div className="input-component">
                <div>
                  <h3 className="montserrat">Descrição</h3>
                  <h5 className='w600'>*</h5>
                </div>
                <input placeholder='Write here' type='text' value={descricao} onChange={(event) => setDescricao(event.target.value)} />
                <h4 className="montserrat">EXEMPLO: Real Brasileiro</h4>
              </div>
              <div className="input-component">
                <div>
                  <h3 className="montserrat">PETAX</h3>
                  <h5 className='w600'>*</h5>
                </div>
                <input placeholder='Write here' type='text' value={petax} onChange={(event) => setPetax(event.target.value)} />
                {/* < CurrencyInput 
                        placeholder="5.85"
                        value={petax}
                        onChange={(event) => setPetax(event)}
                    /> */}
                <h4 className="montserrat">EXEMPLO: 5.85</h4>
              </div>
            </div>

            <div className="button-okay-modal">
              <button className="montserrat w600" onClick={() => callClose()}>Cancelar</button>
              <button
                disabled={codigo === "" && descricao === "" && petax <= 0}
                style={codigo !== "" && descricao !== "" && parseFloat(petax) > 0 ? {} : { backgroundColor: '#ccc', cursor: 'not-allowed' }}
                onClick={() =>
                  changeMoeda()
                }
              >
                Alterar
              </button>
            </div>
          </section>
        </div>


        <ModalInfos
          checked={showModal}
          onClick={() => setShowModal(false)}
          label={label}
        />

        <ModalInfos
          checked={showModal2}
          error
          onClick={() => setShowModal2(false)}
          label={labelError.label}
          sugestao={labelError.sugestao}
        />

        <ModalSure
          checked={showModal3}
          error
          label="Você realmente deseja exluir essa Moeda?"
          onClick={() => setShowModal3(false)}
          delete={() => deleteMoeda(moedaSelecionada)}
        />
      </section>
    </>
  )
}
